<template>
	<div :style="{ minWidth: `${sizeImagePX}px`, maxHeight: `${sizeImagePX}px` }">
		<n-avatar
			v-if="user.picture && !imageError"
			round
			:size="sizeImagePX"
			:src="user.picture"
			:img-props="{
				alt: `${fullname} avatar`,
				onError: () => (imageError = true)
			}"
		/>
		<n-avatar v-else round :size="sizeImagePX">
			<span :style="{ fontSize: `${sizeInitialsPX}px` }">{{ initials }}</span>
		</n-avatar>
	</div>
</template>

<script setup lang="ts">
import { NAvatar } from "naive-ui"
import { computed, ref, watch } from "vue"
import { useAuthStore } from "@/stores/auth"

const { size } = defineProps<{
	size?: "small" | "medium" | "large" | number
}>()

const SIZE_CONFIG = {
	small: 32,
	medium: 40,
	large: 48
} as const

const authStore = useAuthStore()
const user = computed(() => authStore.user)

const imageError = ref(false)

// Reset imageError when user picture changes
watch(
	() => user.value.picture,
	() => {
		imageError.value = false
	}
)

const sizeImagePX = computed(() => {
	if (typeof size === "number") return size
	return SIZE_CONFIG[size ?? "medium"]
})

const sizeInitialsPX = computed(() => sizeImagePX.value / 2.5)

const fullname = computed(() => user.value.username)

const initials = computed(() => {
	return (fullname.value || "")
		.split(" ")
		.map(word => word[0])
		.join("")
		.substring(0, 3)
		.toUpperCase()
})
</script>
